import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { Slider } from '../../components/Slider/Slider.jsx';
import { useNavigate } from 'react-router-dom';
import LogoCarousel from '../../components/Carousel/Carousel.jsx';
import './Home.css';
import logoDiarioSolo from '../../components/Assets/NuevoLogoDiarioModerno.webp';
import logoRadioSolo from '../../components/Assets/NuevoLogoRadioModerno1.webp';
import logoImpresionesSolo from '../../components/Assets/NuevoLogoDiseñoModerno1.webp';
import logoConcursoSolo from '../../components/Assets/NuevoLogoConcursoModerno2.webp';
import logoPueblos from '../../components/Assets/logoPueblos800.webp';

const API_BASE_URL = 'https://la-idea-backend.onrender.com';
const AD_ENABLED = true;

const Home = () => {
  const navigate = useNavigate();

  const [showAd, setShowAd] = useState(false);
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerTitle, setBannerTitle] = useState('Publicidad');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/banner`);
        if (response.data?.imageUrl) {
          setBannerImage(response.data.imageUrl);
          setBannerTitle(response.data.title || 'Publicidad');
          setShowAd(AD_ENABLED);
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error('Error fetching home banner:', error.response ? error.response.data : error.message);
        }
      }
    };

    fetchBanner();
  }, []);

  const closeAd = () => {
    setShowAd(false);
  };

  return (
    <div className="home-container">
      {showAd && bannerImage && (
        <div className="ad-container">
          <button className="close-ad-button" onClick={closeAd}>X</button>
          <img src={bannerImage} alt={bannerTitle} className="ad-image" />
        </div>
      )}
      <Slider />
      <Container className="cards-container">
        <Row>
          <Col md={6} className="mb-4">
            <Card border="dark" onClick={() => navigate('/Diario')} className="navigate-card">
              <Card.Img variant="top" src={logoDiarioSolo} alt="Diario" className="navigate-image" />
              <Card.Body>
                <Card.Title className="card-title">Periódico Digital</Card.Title>
                <Card.Text className="text-center">
                  Versión digital del periódico gráfico
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card border="dark" onClick={() => navigate('/Radio')} className="navigate-card">
              <Card.Img variant="top" src={logoRadioSolo} alt="Radio" className="navigate-image" />
              <Card.Body>
                <Card.Title className="card-title">Radio</Card.Title>
                <Card.Text className="text-center">
                  Programa periodístico radial semanal
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card border="dark" onClick={() => navigate('/Edicion')} className="navigate-card">
              <Card.Img variant="top" src={logoImpresionesSolo} alt="Diseño" className="navigate-image" />
              <Card.Body>
                <Card.Title className="card-title">Diseño</Card.Title>
                <Card.Text className="text-center">
                  Diseño, diagramación e impresión de revistas, periódicos y libros
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card border="dark" onClick={() => navigate('/Concurso')} className="navigate-card">
              <Card.Img variant="top" src={logoConcursoSolo} alt="Concurso" className="navigate-image" />
              <Card.Body>
                <Card.Title className="card-title">Concurso</Card.Title>
                <Card.Text className="text-center">
                  ¡Concurso Nacional de Poesía, Cuento Breve, Dibujo y Fotografía para Adultos, Adolescentes y Niños!
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={12} className="mb-4">
            <Card border="dark" onClick={() => navigate('/Pueblos')} className="navigate-card">
              <Card.Img variant="top" src={logoPueblos} alt="Pueblos" className="navigate-image2" />
              <Card.Body>
                <Card.Title className="card-title">Voces de los Pueblos</Card.Title>
                <Card.Text className="text-center">
                  Descubre las historias y voces de nuestros pueblos
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <LogoCarousel />
    </div>
  );
};

export default Home;
